import { Box } from '@apia/theme';
import { useContext, useRef } from 'react';
import { usePrevious } from 'ahooks';
import { AutocompleteContext } from './AutocompleteContext';
import { TStoredOption } from './store';
import { useColor } from './ColorContext';
import { ApiaUtil } from '@apia/components';

function scrollIntoView(element: HTMLElement) {
  element.scrollIntoView({
    behavior: 'auto',
    block: 'nearest',
    inline: 'nearest',
  });
}

const Option = ({ option }: { option: TStoredOption }) => {
  const {
    id,
    keyhandler: {
      useIsFocused,
      setValue,
      lastShowValue,
      confirmChangeValue,
      toggleBlur,
    },
    readonly,
  } = useContext(AutocompleteContext);

  const ref = useRef<HTMLElement | null>(null);

  const isFocused = useIsFocused(option.id);
  const wasFocused = usePrevious(isFocused);

  if (isFocused && !wasFocused && ref.current) scrollIntoView(ref.current);

  const assignRef = (el: HTMLElement) => {
    if (!el) return;
    ref.current = el;
    if (isFocused && !wasFocused) scrollIntoView(el);
  };

  const color = useColor();

  return (
    <Box
      ref={assignRef}
      data-value={option.value}
      className={`autocomplete__option ${isFocused ? 'focused' : ''}`}
      onMouseDown={async () => {
        if (readonly) return;
        toggleBlur(true);
        setTimeout(() => {
          document
            .querySelector<HTMLElement>(`[data-autocompleteid="input__${id}"]`)
            ?.focus();
        }, 0);
        if (confirmChangeValue && lastShowValue?.value) {
          if (option.value != lastShowValue?.value) {
            const hasConfirmed = await ApiaUtil.instance.dialogs.confirm({
              title: window.LBLCHANGEUSRLOGIN ?? 'hola',
              children: window.LBLTABLEDATALOST ?? 'adios',
            });
            if (hasConfirmed) {
              setValue(option?.value);
            } else {
              setValue(lastShowValue?.value);
            }
          }
        } else {
          setValue(option?.value);
        }
      }}
      id={`list__item__${id}__${option.value}`}
      role="option"
      aria-selected={isFocused}
      sx={{ '&.autocomplete__option[role="option"]': { color } }}
    >
      {option.label || '\u00A0'}
    </Box>
  );
};

export default Option;
